import { Handle, Position } from '@xyflow/react';

export default function StoreNode({ data }) {
  const { store } = data;
  const hasDiscrepancy = store.discrepancies?.length > 0;
  const isClickable = store.in_db === false;

  return (
    <div
      className={`px-4 py-3 rounded-xl border-2 shadow-lg min-w-[180px] transition-all ${isClickable ? 'cursor-pointer' : 'cursor-default'} ${
        !store.in_db
          ? 'bg-amber-900/30 border-amber-500/60 hover:border-amber-400'
          : hasDiscrepancy
            ? 'bg-yellow-900/20 border-yellow-600/50 hover:border-yellow-400'
            : 'bg-bg-elevated border-accent/40 hover:border-accent'
      }`}
    >
      <Handle type="source" position={Position.Bottom} className="!bg-accent" />
      <div className="flex items-center gap-2 mb-1">
        <span className="text-base">🏪</span>
        <span className="font-semibold text-slate-100 text-sm truncate max-w-[130px]">{store.name}</span>
        {!store.in_db && <span className="text-amber-400 text-base ml-auto" title="Click para crear en tu sistema">⚠ click</span>}
      </div>
      <div className="text-xs text-slate-400 font-mono">{store.external_id}</div>
      {store.city_name && <div className="text-xs text-slate-500">{store.city_name}</div>}
      <div className="flex gap-1 mt-2 flex-wrap">
        {store.mp_store_id
          ? <span className="text-xs px-1.5 py-0.5 rounded bg-emerald-900/40 text-emerald-300 border border-emerald-700/40">MP ✓</span>
          : <span className="text-xs px-1.5 py-0.5 rounded bg-amber-900/40 text-amber-300 border border-amber-700/40">Sin sync</span>
        }
        {!store.in_db && (
          <span className="text-xs px-1.5 py-0.5 rounded bg-amber-900/40 text-amber-300 border border-amber-700/40">Solo en MP</span>
        )}
      </div>
    </div>
  );
}
